/**
 * @author        yontaek@zumper.com (Yon Taek Chung)
 * @copyright     Copyright (c) 2021, Zumper
 * @description   HomepageAutocomplete Component
 */

import type { AutocompleteApiResult } from '@zcode/bizos'
import { SharedAutocomplete } from '@zcode/nr/es/shared/components/Autocomplete/SharedAutocomplete'
import type { SharedAutocompleteProps } from '@zcode/nr/es/shared/components/Autocomplete/SharedAutocomplete'
import React from 'react'
import { useDispatch } from 'react-redux'
import { mixpanelAutocompleteResultClick } from '../../modules/mixpanel/thunks/mixpanelAutocompleteResultClick'

import { PAGE_NAMES } from '@zcode/mixpanel'
import defaultTheme from './HomepageAutocompleteTheme.module.scss'

export const HomepageAutocomplete = ({
  fillInputOnSelect,
  hasError,
  isShortTerm,
  onSelectAutocompleteResult,
  origin,
  placeholder,
  theme,
}: Pick<
  SharedAutocompleteProps,
  | 'fillInputOnSelect'
  | 'hasError'
  | 'isShortTerm'
  | 'onSelectAutocompleteResult'
  | 'origin'
  | 'placeholder'
  | 'theme'
>) => {
  const dispatch = useDispatch()
  let autocompleteTheme = { ...defaultTheme }
  if (theme) {
    autocompleteTheme = { ...defaultTheme, ...theme }
  }

  const dispatchMixpanelAutocompleteResultClick = ({
    result,
    index,
  }: {
    result: AutocompleteApiResult
    index: number
  }) => {
    dispatch(mixpanelAutocompleteResultClick({ result, index }))
  }

  return (
    <SharedAutocomplete
      dispatchMixpanelAutocompleteResultClick={dispatchMixpanelAutocompleteResultClick}
      fillInputOnSelect={fillInputOnSelect}
      hasError={hasError}
      isShortTerm={isShortTerm}
      onSelectAutocompleteResult={onSelectAutocompleteResult}
      origin={origin}
      pageName={PAGE_NAMES.HOMEPAGE}
      placeholder={placeholder}
      theme={autocompleteTheme}
    />
  )
}
